import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './about.css';

const About = () => (
  <div className="gpt3__possibility section__padding" id="about">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h1 className="gradient__text">Who We Are</h1>
      <p>It is a long established fact that a reader will b that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like</p>
        <h1 className="gradient__text">What We Do</h1>
      <p>It is a long established fact that a reader will bsometimes on purpose (injected humour and the like  a page when e distracted by the readable content ofts layout. The point of using Lorem Ipsum is looking at i</p>
     
    </div>
  </div>
);

export default About;
